import { createPortal } from 'react-dom';
import styles from './Modal.module.scss';
import { ReactComponent as CloseIcon } from '../../svg/close.svg';

const Modal = ({
	children,
	showControls = true,
	title,
	close = () => {},
	openModal,
}) => {
	if (!openModal) {
		return null;
	}
	return createPortal(
		<div className={`${styles.modal} ${openModal ? styles.open : ''}`}>
			<div className={styles.wrapper}>
				{showControls && (
					<a
						className={styles.close}
						href="/"
						onClick={(e) => {
							e.preventDefault();
							close();
						}}
					>
						<CloseIcon />
					</a>
				)}
				{title && (
					<div className={styles.title}>
						{title}
					</div>
				)}
				{children && (
					<div className={styles.content}>
						{children}
					</div>
				)}
			</div>
			<div
				className={styles.background}
				onClick={(e) => {
				e.preventDefault();
				close();
			}}></div>
		</div>,
		document.body
	);
};

export default Modal;
